import { render } from "./NewTDAParticipant.vue?vue&type=template&id=0c5375fa&scoped=true"
import script from "./NewTDAParticipant.vue?vue&type=script&lang=js"
export * from "./NewTDAParticipant.vue?vue&type=script&lang=js"

import "./NewTDAParticipant.vue?vue&type=style&index=0&id=0c5375fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5375fa"]])

export default __exports__